import { useEffect } from 'react'
import { useRouter } from 'next/router'
import Spinner from 'components/common/Spinner'
import { useUserNotifications } from 'hooks/api/user/useUser'

const UserHome = () => {
	const router = useRouter()
	const { userSlug, ...restQuery } = router?.query || {}
	const { data: notifications, isLoading } = useUserNotifications(userSlug)

	useEffect(() => {
		if (!router.isReady || !userSlug || isLoading) return

		const pathname = notifications?.hasOpenNotifications
			? '/users/[userSlug]/notifications'
			: '/users/[userSlug]/properties'

		router.replace({
			pathname,
			query: { userSlug, ...restQuery },
		})
	}, [router.isReady, userSlug, isLoading, notifications])

	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				minHeight: '100vh',
			}}
		>
			<Spinner size={60} type='Grid' />
		</div>
	)
}

export default UserHome
